import React, { useState, useEffect, useRef } from 'react';
import { View, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, SizeTypeTokens } from '@voltmoney/schema';
import { OtpInput } from '../OtpInput/OtpInput';
import Space from '../../space/Space';
import ThemeProvider from "@voltmoney/theme";
const OtpModalScreen = ({ id, charLimit = 6, resendTimer = 15, action, isDarkMode, triggerAction, onChangeText, state = InputStateToken.DEFAULT, otpAction, caption, }) => {
    const inputRef = useRef(null);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [isSuccessState, setIsSuccessState] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [seconds, setSeconds] = useState(resendTimer);
    const [isRunning, setIsRunning] = useState(true);
    const [otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [successText, setSuccessText] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        setSeconds(resendTimer);
        setIsRunning(true);
    }, [resendTimer]);
    useEffect(() => {
        setShowOtpModal(true);
        setIsRunning(true);
    }, []);
    useEffect(() => {
        if (successText) {
            setTimeout(() => {
                setSuccessText(false);
            }, 3000);
        }
    }, [showTimer, seconds]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (state === 'SUCCESS')
            setIsSuccessState(true);
        else if (state === 'ERROR') {
            setIsErrorState(true);
            setLoader(false);
        }
        else if (state === 'DISABLED')
            setOtpLimitExceeded(true);
        else {
            setIsErrorState(false);
            setOtpLimitExceeded(false);
        }
    }, [state]);
    const handleReset = () => {
        setSeconds(resendTimer);
        setIsRunning(true);
        setLoader(false);
        setIsErrorState(false);
        setIsSuccessState(true);
    };
    const returnOtpModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1 },
            React.createElement(View, { style: { paddingBottom: 36 } },
                React.createElement(OtpInput, { id: id, numberOfDigits: charLimit, ref: inputRef, editable: !loader, onTextChange: (text) => {
                        if (onChangeText) {
                            onChangeText(text);
                        }
                        if (text.length === charLimit) {
                            if (action && triggerAction && !otpLimitExceeded) {
                                setLoader(true);
                                setIsErrorState(false);
                                triggerAction({
                                    ...action,
                                    payload: {
                                        ...action.payload,
                                        value: text,
                                    },
                                });
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8, borderColor: isDarkMode ? 'white' : '#DFDFDE' },
                        pinCodeTextStyle: isDarkMode ? { fontSize: 15, color: 'white' } : { fontSize: 15 },
                        containerStyle: { width: 310 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                loader && !isErrorState && !otpLimitExceeded && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                (isErrorState || otpLimitExceeded) && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: caption?.error ? caption?.error : "" }))),
                isSuccessState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Success_100, label: caption?.success ? caption?.success : "" }))),
                React.createElement(View, { style: {
                        paddingTop: 36,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { disabled: otpLimitExceeded, style: { marginLeft: 8 }, onPress: () => {
                            if ((seconds === 0 && !otpLimitExceeded)) {
                                setSuccessText(true);
                                setShowTimer(false);
                                handleReset();
                                //@ts-ignore
                                inputRef?.current?.clear();
                                if (triggerAction) {
                                    triggerAction(otpAction);
                                }
                            }
                            else
                                setShowTimer(true);
                        } },
                        React.createElement(Typography, { id: 'txt_commonScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0 && !otpLimitExceeded
                                ? ColorTokens.Primary_100
                                : isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                !successText && showTimer && seconds > 0 && !otpLimitExceeded && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }))),
                successText &&
                    React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Typography, { label: `OTP has been resent.`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Secondary_100 })))));
    };
    return (showOtpModal && returnOtpModal());
};
const styles = StyleSheet.create({
    otpContainer: {
        paddingHorizontal: 8,
        paddingVertical: 8,
        backgroundColor: '#E7F4ED',
        width: 107,
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
        borderRadius: 6
    },
});
export default OtpModalScreen;
